
import { RelativeTime } from 'lib-core'


export default RelativeTime
